import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromMenu from "../reducers/menu.reducer";

export const menuState = createFeatureSelector<fromMenu.State>(
    fromMenu.menuFeatureKey,
);

export const selectMenuEntry = createSelector(
    menuState,
    (state: fromMenu.State) => state.entry,
);

/**
 * Return all menu categories, including non-visible categories
 */
export const selectAllCategories = createSelector(
    menuState,
    (state: fromMenu.State) => state.categories,
);

/**
 * Return all **visible** menu categories, excluding non-visible categories
 */
export const selectCategories = createSelector(
    selectAllCategories,
    (categories) =>
        categories
            ? Object.fromEntries(
                  Object.entries(categories).filter(
                      ([_key, category]) => category.visibility,
                  ),
              )
            : undefined,
);

export const selectLinks = createSelector(
    menuState,
    (state: fromMenu.State) => state.links,
);
